<template>
  <p class="price price-component" :class="{ 'price--is-small': isSmall }" :aria-label="priceAriaLabel" role="text">
    <slot name="prefix">
      <span aria-hidden="true" v-if="prefix" class="price__prefix">{{ prefix }}</span>
    </slot>
    <span aria-hidden="true" v-if="isSmall" class="price__main">
        <span class="price__currency">{{ currency }}</span>
        <span class="price__int">{{ priceObj.int }}</span>
        <span class="price__decimal" v-if="priceObj.decimal">{{ showDecimalPoint ? '.' : '' }}{{ priceObj.decimal }}</span>
      </span>
    <template v-else>
      <span aria-hidden="true" class="price__currency">{{ currency }}</span>
      <span aria-hidden="true" class="price__int">{{ priceObj.int }}</span>
      <span aria-hidden="true" class="price__decimal" v-if="priceObj.decimal">{{ showDecimalPoint ? '.' : '' }}{{ priceObj.decimal }}</span>
    </template>
    <span aria-hidden="true" class="price__unit">{{ unit }}<priceVATTip v-if="!suffix" />
    </span>
    <slot name="suffix">
      <span aria-hidden="true" v-if="suffix" class="price__suffix">{{ suffix }}<priceVATTip />
      </span>
  </slot>
  </p>
</template>
<script>
import { getCurrency, getCurrencySymbol } from '@/utils/currency';

export default {
  name: 'price',
  props: {
    currency: {
      type: String,
      default: getCurrencySymbol(getCurrency()),
    },
    price: String,
    unit: String,
    prefix: String,
    suffix: String,
    size: {
      type: String,
      default: '',
      validator: (val) => val ? ['small'].includes(val) : true,
    },
    showDecimalPoint: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    isSmall() {
      return this.size === 'small' || this.$context.is.mobile;
    },
    priceNum() {
      return this.price.replace(this.currency, '');
    },
    priceObj() {
      const [int, decimal] = this.priceNum.split('.');
      return {
        int,
        decimal,
      };
    },
    priceAriaLabel() {
      return `${this.currency}${this.price}${this.unit}`;
    }
  },
};
</script>
<style lang="scss" scoped>
@import '@/styles/_variables.scss';
.price.price-component {
  // flex: 1;
  padding-right: 24px;
  padding-left: 0;
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
  &.price--is-small {
    padding-right: 0;
    .price__currency {
      font-size: 12px;
      line-height: 1.5;
      text-transform: uppercase;
    }
    .price__int {
      font-size: 20px;
      line-height: 1.2;
    }
    .price__decimal {
      font-size: 12px;
      line-height: 1.5;
    }
    .price__unit {
      font-size: 12px;
      line-height: 1.2;
    }
    .price__suffix,
    .price__prefix {
      font-size: 14px;
      line-height: 1.2;
    }
    & + & {
      padding-left: 12px;
      border-left: 1px solid #e0e0e6;
    }
  }
  .price__main {
    display: flex;
    align-items: flex-start;
  }
  .price__currency {
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 36px;
    color: #00053d;
    margin-right: 2px;
    text-transform: uppercase;
  }

  .price__int {
    font-family: $happy-display;
    font-style: normal;
    font-weight: 400;
    font-size: 32px;
    line-height: 48px;
    color: #00053d;
    margin-right: 2px;
  }

  .price__decimal {
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 36px;
    color: #00053d;
    margin-right: 2px;
  }

  .price__unit {
    font-style: normal;
    font-weight: 450;
    font-size: 16px;
    line-height: 38px;
    color: #00053d;
    align-self: flex-end;
  }

  .price__suffix,
  .price__prefix {
    color: #515079;
    font-size: 16px;
    font-style: normal;
    font-weight: 450;
    line-height: 38px;
    align-self: flex-end;
  }

  .price__suffix {
    margin-left: 8px;
  }

  .price__prefix {
    margin-right: 8px;
  }

  & + & {
    padding-right: 0;
    padding-left: 24px;
    border-left: 2px solid #b8b8c4;
  }
}
</style>
